/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Location {
    'use strict';

    import BusinessInfoSettingEnum = Meevo.Model.BusinessInfoSettingEnum;
    import SubscriptionStatusEnum = Meevo.Model.SubscriptionStatusEnum;

    export class LocationContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public searchResultItemTemplate = "{{storeName}}";

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $q: angular.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.baseEndpoint = appSettings.API_ENDPOINTS.location;
            this.sectionTemplatePath = 'app/plugins/location/sectionViews/';

            this.buildCrudSecurityKeys(this.securityKeys.MANAGEMENT_LOCATION_TAB_MAIN);
            this.entityType = 'location';

            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_LOCATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, 'SECTION_MAIN', 'main.html', true, false, this.appSettings.API_ENDPOINTS.location, "",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.LocationMaintenanceMain, this.busyService, this.$q, this.modalService, this.securityKeys.MANAGEMENT_LOCATION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.storeName;
        }

        get showFooterAddNew(): boolean {
            return false;
        }

        save() {
            this.busyService.start();
            if (this.selectedSection instanceof MainSection) {
                let section = <MainSection>this.selectedSection;

                return section.confirmSave().then(() => { 
                    let loc = super.save();
                    this.busyService.stop();
                    return loc;
                });
            } else {
                let loc = super.save();
                this.busyService.stop();
                return loc;
            }
        }

        public selectSection(item): void {
            if (this.selectedSection && this.selectedSection != item && this.navigationBlocked) {
                this.modalService.alert("MESSAGE_PENDING_CHANGES");
            } else {
                // Can't selected another section when adding and copying (!this.itemId)
                if (this.isAdding || this.isCopying)
                    return;

                var prevSection = this.selectedSection;
                if (Model.Guard.isSomething(prevSection))
                    prevSection.prevUnselected(); // implement prevUnselected action

                this.selectedSection = item;

                if (!this.selectedSection.handlesOwnCrud) {
                    this.loadingInProgress = true;

                    var newSectionEndPoint = this.selectedSection.sectionEndpoint;

                    this.dataService.customMethodData(`api/${this.selectedSection.baseEndpoint}/${this.itemId}`, 'POST', {
                        settings: [
                            BusinessInfoSettingEnum.EnableAutoBillingService,
                            BusinessInfoSettingEnum.EFTToBeProcessedStatusEnum,
                            BusinessInfoSettingEnum.EnableMembershipBilling,
                            BusinessInfoSettingEnum.EnableAppointmentNotification,
                            BusinessInfoSettingEnum.EnableOnlineBooking,
                            BusinessInfoSettingEnum.EnableThirdPartyIntegration,
                            BusinessInfoSettingEnum.EnableOnlineWalkinManager                            
                        ]
                    }).then((response) => {
                        let data = response.data;

                        this.selectedSection.model = data;
                        this.selectedSection.sectionModelRetrieved();
                        this.selectedSection.activate();

                        if (this.selectedSection.isPrimarySection) {
                            this.updateCoBarData(data);
                            this.initializeHeader(data);
                        }

                    }).finally(() => {
                        this.loadingInProgress = false;
                    });
                }
                this.selectedSection.selected();

                this.usageTrackingLog(Meevo.Model.VerbEnum.Viewed, null);
            }
        }

        get showEdit(): boolean {
            if (this.selectedSection instanceof MainSection) {
                let section = <MainSection>this.selectedSection;

                return super.showEditLogic() && (section.model.subscriptionStatus == SubscriptionStatusEnum.Active || section.model.subscriptionStatus === SubscriptionStatusEnum.Pending);
            }

            return super.showEditLogic();
        }
    }
}